import API from 'services/API';

// Log
export const getAllLogs = () => API.get('/log');

